/**
 * @generated SignedSource<<43e04c8a4225051f56a1410c47082d61>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "count": null,
  "cursor": null,
  "direction": "forward",
  "path": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "CommentCard_comment"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      (v0/*: any*/),
      (v0/*: any*/),
      (v0/*: any*/),
      (v0/*: any*/),
      (v0/*: any*/),
      (v0/*: any*/),
      (v0/*: any*/),
      (v0/*: any*/),
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "comments"
        ]
      }
    ]
  },
  "name": "Comment_comment",
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isFromAdminUser",
      "storageKey": null
    },
    {
      "alias": "comments",
      "args": null,
      "concreteType": "CommentConnection",
      "kind": "LinkedField",
      "name": "__CommentsPanel_comments_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CommentEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Comment",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                (v2/*: any*/),
                {
                  "alias": "comments",
                  "args": null,
                  "concreteType": "CommentConnection",
                  "kind": "LinkedField",
                  "name": "__CommentsPanel_comments_connection",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CommentEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Comment",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v1/*: any*/),
                            (v2/*: any*/),
                            {
                              "alias": "comments",
                              "args": null,
                              "concreteType": "CommentConnection",
                              "kind": "LinkedField",
                              "name": "__CommentsPanel_comments_connection",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "CommentEdge",
                                  "kind": "LinkedField",
                                  "name": "edges",
                                  "plural": true,
                                  "selections": [
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": "Comment",
                                      "kind": "LinkedField",
                                      "name": "node",
                                      "plural": false,
                                      "selections": [
                                        (v1/*: any*/),
                                        (v2/*: any*/),
                                        {
                                          "alias": "comments",
                                          "args": null,
                                          "concreteType": "CommentConnection",
                                          "kind": "LinkedField",
                                          "name": "__CommentsPanel_comments_connection",
                                          "plural": false,
                                          "selections": [
                                            {
                                              "alias": null,
                                              "args": null,
                                              "concreteType": "CommentEdge",
                                              "kind": "LinkedField",
                                              "name": "edges",
                                              "plural": true,
                                              "selections": [
                                                {
                                                  "alias": null,
                                                  "args": null,
                                                  "concreteType": "Comment",
                                                  "kind": "LinkedField",
                                                  "name": "node",
                                                  "plural": false,
                                                  "selections": [
                                                    (v1/*: any*/),
                                                    (v2/*: any*/),
                                                    {
                                                      "alias": "comments",
                                                      "args": null,
                                                      "concreteType": "CommentConnection",
                                                      "kind": "LinkedField",
                                                      "name": "__CommentsPanel_comments_connection",
                                                      "plural": false,
                                                      "selections": [
                                                        {
                                                          "alias": null,
                                                          "args": null,
                                                          "concreteType": "CommentEdge",
                                                          "kind": "LinkedField",
                                                          "name": "edges",
                                                          "plural": true,
                                                          "selections": [
                                                            {
                                                              "alias": null,
                                                              "args": null,
                                                              "concreteType": "Comment",
                                                              "kind": "LinkedField",
                                                              "name": "node",
                                                              "plural": false,
                                                              "selections": [
                                                                (v1/*: any*/),
                                                                (v2/*: any*/),
                                                                {
                                                                  "alias": "comments",
                                                                  "args": null,
                                                                  "concreteType": "CommentConnection",
                                                                  "kind": "LinkedField",
                                                                  "name": "__CommentsPanel_comments_connection",
                                                                  "plural": false,
                                                                  "selections": [
                                                                    {
                                                                      "alias": null,
                                                                      "args": null,
                                                                      "concreteType": "CommentEdge",
                                                                      "kind": "LinkedField",
                                                                      "name": "edges",
                                                                      "plural": true,
                                                                      "selections": [
                                                                        {
                                                                          "alias": null,
                                                                          "args": null,
                                                                          "concreteType": "Comment",
                                                                          "kind": "LinkedField",
                                                                          "name": "node",
                                                                          "plural": false,
                                                                          "selections": [
                                                                            (v1/*: any*/),
                                                                            (v2/*: any*/),
                                                                            {
                                                                              "alias": "comments",
                                                                              "args": null,
                                                                              "concreteType": "CommentConnection",
                                                                              "kind": "LinkedField",
                                                                              "name": "__CommentsPanel_comments_connection",
                                                                              "plural": false,
                                                                              "selections": [
                                                                                {
                                                                                  "alias": null,
                                                                                  "args": null,
                                                                                  "concreteType": "CommentEdge",
                                                                                  "kind": "LinkedField",
                                                                                  "name": "edges",
                                                                                  "plural": true,
                                                                                  "selections": [
                                                                                    {
                                                                                      "alias": null,
                                                                                      "args": null,
                                                                                      "concreteType": "Comment",
                                                                                      "kind": "LinkedField",
                                                                                      "name": "node",
                                                                                      "plural": false,
                                                                                      "selections": [
                                                                                        (v1/*: any*/),
                                                                                        (v2/*: any*/),
                                                                                        {
                                                                                          "alias": "comments",
                                                                                          "args": null,
                                                                                          "concreteType": "CommentConnection",
                                                                                          "kind": "LinkedField",
                                                                                          "name": "__CommentsPanel_comments_connection",
                                                                                          "plural": false,
                                                                                          "selections": [
                                                                                            {
                                                                                              "alias": null,
                                                                                              "args": null,
                                                                                              "concreteType": "CommentEdge",
                                                                                              "kind": "LinkedField",
                                                                                              "name": "edges",
                                                                                              "plural": true,
                                                                                              "selections": [
                                                                                                {
                                                                                                  "alias": null,
                                                                                                  "args": null,
                                                                                                  "concreteType": "Comment",
                                                                                                  "kind": "LinkedField",
                                                                                                  "name": "node",
                                                                                                  "plural": false,
                                                                                                  "selections": [
                                                                                                    (v1/*: any*/),
                                                                                                    (v2/*: any*/),
                                                                                                    {
                                                                                                      "alias": "comments",
                                                                                                      "args": null,
                                                                                                      "concreteType": "CommentConnection",
                                                                                                      "kind": "LinkedField",
                                                                                                      "name": "__CommentsPanel_comments_connection",
                                                                                                      "plural": false,
                                                                                                      "selections": [
                                                                                                        {
                                                                                                          "alias": null,
                                                                                                          "args": null,
                                                                                                          "concreteType": "CommentEdge",
                                                                                                          "kind": "LinkedField",
                                                                                                          "name": "edges",
                                                                                                          "plural": true,
                                                                                                          "selections": [
                                                                                                            {
                                                                                                              "alias": null,
                                                                                                              "args": null,
                                                                                                              "concreteType": "Comment",
                                                                                                              "kind": "LinkedField",
                                                                                                              "name": "node",
                                                                                                              "plural": false,
                                                                                                              "selections": [
                                                                                                                (v1/*: any*/),
                                                                                                                (v2/*: any*/),
                                                                                                                (v3/*: any*/)
                                                                                                              ],
                                                                                                              "storageKey": null
                                                                                                            },
                                                                                                            (v4/*: any*/)
                                                                                                          ],
                                                                                                          "storageKey": null
                                                                                                        },
                                                                                                        (v5/*: any*/)
                                                                                                      ],
                                                                                                      "storageKey": null
                                                                                                    },
                                                                                                    (v3/*: any*/)
                                                                                                  ],
                                                                                                  "storageKey": null
                                                                                                },
                                                                                                (v4/*: any*/)
                                                                                              ],
                                                                                              "storageKey": null
                                                                                            },
                                                                                            (v5/*: any*/)
                                                                                          ],
                                                                                          "storageKey": null
                                                                                        },
                                                                                        (v3/*: any*/)
                                                                                      ],
                                                                                      "storageKey": null
                                                                                    },
                                                                                    (v4/*: any*/)
                                                                                  ],
                                                                                  "storageKey": null
                                                                                },
                                                                                (v5/*: any*/)
                                                                              ],
                                                                              "storageKey": null
                                                                            },
                                                                            (v3/*: any*/)
                                                                          ],
                                                                          "storageKey": null
                                                                        },
                                                                        (v4/*: any*/)
                                                                      ],
                                                                      "storageKey": null
                                                                    },
                                                                    (v5/*: any*/)
                                                                  ],
                                                                  "storageKey": null
                                                                },
                                                                (v3/*: any*/)
                                                              ],
                                                              "storageKey": null
                                                            },
                                                            (v4/*: any*/)
                                                          ],
                                                          "storageKey": null
                                                        },
                                                        (v5/*: any*/)
                                                      ],
                                                      "storageKey": null
                                                    },
                                                    (v3/*: any*/)
                                                  ],
                                                  "storageKey": null
                                                },
                                                (v4/*: any*/)
                                              ],
                                              "storageKey": null
                                            },
                                            (v5/*: any*/)
                                          ],
                                          "storageKey": null
                                        },
                                        (v3/*: any*/)
                                      ],
                                      "storageKey": null
                                    },
                                    (v4/*: any*/)
                                  ],
                                  "storageKey": null
                                },
                                (v5/*: any*/)
                              ],
                              "storageKey": null
                            },
                            (v3/*: any*/)
                          ],
                          "storageKey": null
                        },
                        (v4/*: any*/)
                      ],
                      "storageKey": null
                    },
                    (v5/*: any*/)
                  ],
                  "storageKey": null
                },
                (v3/*: any*/)
              ],
              "storageKey": null
            },
            (v4/*: any*/)
          ],
          "storageKey": null
        },
        (v5/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Comment",
  "abstractKey": null
};
})();

node.hash = "2ef9adc577742e69afec5ead6803d345";

module.exports = node;
